import type { I_AccordionProps } from '@/types/Accordion';
import { E_AccordionType } from '@/types/Accordion';
import { Accordion as AccordionUI } from '@/ui/accordion';

import { AccordionItem } from './AccordionItem';

export const Accordion = ({ items, className, defaultValue }: I_AccordionProps) => {
  return (
    <AccordionUI type={E_AccordionType.MULTIPLE} defaultValue={defaultValue} className={className}>
      {items.map(({ value, triggerContent, children }) => (
        <AccordionItem key={value} value={value} triggerContent={triggerContent}>
          {children}
        </AccordionItem>
      ))}
    </AccordionUI>
  );
};
